export const MARKETING_MODALS = {
  DISCOUNT_REQUEST: 'marketingDiscountRequest',
  HOSTING_REQUEST: 'marketingHostingRequest',
} as const;

export type MarketingModalKey = typeof MARKETING_MODALS[keyof typeof MARKETING_MODALS];

